import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import s from './CircleLoader.scss'


const CircleLoader = ({ className, color, center }) => (
  <div className={cx(className, s.loader, { [s[color]]: color, [s.center]: center })} />
)

CircleLoader.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf(['brand', 'white']),
  center: PropTypes.bool,
}

CircleLoader.defaultProps = {
  color: 'brand',
}


export default CircleLoader
